import { SfLog } from '@app/adapters/logger'
import SFetch from '@app/utils/sfetch'

import { getSignal } from '@app/adapters/abort'

function resolveCompanyId(endpointParams) {
  const companyId =
    endpointParams.companyId ||
    endpointParams.notifications?.activeCompanyId ||
    Silverfin.jsonParams.company_id

  if (!companyId) {
    SfLog.info('communications API called with no company_id', {
      extra: {
        ...Silverfin.jsonParams,
      },
    })
  }

  return companyId
}

export default {
  getContextCommunication(endpointParams = {}) {
    const companyId = resolveCompanyId(endpointParams)
    if (!companyId) return

    const params = {
      ...Silverfin.jsonParams,
      company_id: companyId,
      context_type: endpointParams.contextType,
      context_id: endpointParams.contextId,
      ledger_id: endpointParams.ledgerId,
      communication_item_type: endpointParams.communicationItemType,
      communication_item_id: endpointParams.communicationItemId,
    }
    const url = Silverfin.Routes.communications_path(params)

    return SFetch.jsonWithAlert(url, { signal: getSignal('communications') })
  },

  getPulseCommunication(endpointParams = {}) {
    const companyId = resolveCompanyId(endpointParams)
    if (!companyId) return

    const params = {
      ...Silverfin.jsonParams,
      company_id: companyId,
      ledger_id: endpointParams.ledgerId,
    }
    const url = Silverfin.Routes.pulse_communications_path(params)

    return SFetch.jsonWithAlert(url, { signal: getSignal('communications') })
  },

  getNotificationsCommunication(endpointParams = {}) {
    const companyId = resolveCompanyId(endpointParams)
    if (!companyId) return

    const params = {
      ...Silverfin.jsonParams,
      company_id: companyId,
    }
    const url = Silverfin.Routes.notifications_communications_path(params)

    return SFetch.jsonWithAlert(url, { signal: getSignal('communications') })
  },

  async getMentionUsernames(endpointParams = {}) {
    const companyId =
      endpointParams.companyId || Silverfin.jsonParams.company_id

    const params = {
      ...Silverfin.jsonParams,
      company_id: companyId,
      // Changes the URL (= cache key) so a legacy array-shaped response cached
      // by an older bundle can never be served to this one during a deploy.
      include_pulse_usernames: true,
    }

    const url = Silverfin.Routes.mentionable_usernames_path(params)

    const data = await SFetch.jsonWithAlert(url, {
      signal: getSignal('communications'),
    })

    // jsonWithAlert resolves undefined on failed or aborted requests.
    return {
      usernames: data?.usernames ?? [],
      pulseUsernames: data?.pulseUsernames ?? [],
    }
  },
}
